module.exports = __webpack_public_path__ + "img/icon-gp-128x128-01-nested.49f5603d.svg";